import React from 'react';

const categories = [
    { name: 'Allopathic', image: '/category_images/cat_allopathic.png' },
    { name: 'Ayurvedic', image: '/category_images/cat_ayurvedic.png' },
    { name: 'Cosmetics', image: '/category_images/cat_cosmetics.png' },
    { name: 'Food Product', image: '/category_images/cat_food.png' },
    { name: 'General', image: '/category_images/cat_general.png' },
    { name: 'Generic', image: '/category_images/cat_generic.png' },
    { name: 'Homeopathic', image: '/category_images/cat_homeopathic.png' },
    { name: 'Insecticide', image: '/category_images/cat_insecticide.png' },
    { name: 'Surgical', image: '/category_images/cat_surgical.png' },
    { name: 'Veternary', image: '/category_images/cat_veterinary.png' }
];

const CategoryCarousel = ({ onCategoryClick }) => {
    return (
        <div className="mb-16">
            <h3 className="text-2xl font-bold text-gray-800 mb-8 border-b pb-2 text-center">Shop by Category</h3>
            <div className="grid grid-cols-2 sm:grid-cols-5 gap-3 md:gap-4 max-w-5xl mx-auto">
                {categories.map((category, index) => (
                    <div
                        key={index}
                        onClick={() => onCategoryClick(category.name)}
                        className="cursor-pointer group flex flex-col items-center bg-white p-4 rounded-xl shadow-sm hover:shadow-md transition-all duration-300 border border-gray-100 hover:border-sky-500"
                    >
                        <div className="w-20 h-20 md:w-24 md:h-24 rounded-lg overflow-hidden mb-3 bg-sky-50 flex items-center justify-center">
                            <img
                                src={category.image}
                                alt={category.name}
                                className="w-full h-full object-contain transform group-hover:scale-110 transition-transform duration-500"
                                onError={(e) => {
                                    e.target.onerror = null; 
                                    e.target.src = `https://placehold.co/200x200/0ea5e9/ffffff?text=${category.name.split(' ')[0]}`;
                                }}
                            />
                        </div>
                        <span className="text-xs md:text-sm font-bold text-gray-700 group-hover:text-sky-600 text-center leading-tight">
                            {category.name}
                        </span>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default CategoryCarousel;